import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme, css } from "@emotion/react";
import { useThemeProps, Button } from "@wsui/base";
function PostsModuleArchiveLink(props) {
  useTheme();
  props = useThemeProps({
    props,
    name: "MunicipioPostsModuleArchiveLink"
  });
  let {
    label,
    uri,
    variant = "primary",
    align = "flex-start",
    ...restProps
  } = props;
  return /* @__PURE__ */jsx("div", {
    css: /* @__PURE__ */css("display:flex;flex-flow:column;align-items:", align, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PostsModuleArchiveLink;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9qZWFuZnJlZHJpay9wcm9qZWN0cy93c3VpL3BhY2thZ2VzL211bmljaXBpby9zcmMvUG9zdHNNb2R1bGVBcmNoaXZlTGluay5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZWMiLCJmaWxlIjoiL1VzZXJzL2plYW5mcmVkcmlrL3Byb2plY3RzL3dzdWkvcGFja2FnZXMvbXVuaWNpcGlvL3NyYy9Qb3N0c01vZHVsZUFyY2hpdmVMaW5rLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywgdXNlVGhlbWUgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIjtcbmltcG9ydCB7IHVzZVRoZW1lUHJvcHMsIEJ1dHRvbiB9IGZyb20gXCJAd3N1aS9iYXNlXCI7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIFBvc3RzTW9kdWxlQXJjaGl2ZUxpbmsocHJvcHMpIHtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICBwcm9wcyA9IHVzZVRoZW1lUHJvcHMoeyBwcm9wcywgbmFtZTogXCJNdW5pY2lwaW9Qb3N0c01vZHVsZUFyY2hpdmVMaW5rXCIgfSk7XG4gIGxldCB7XG4gICAgbGFiZWwsXG4gICAgdXJpLFxuICAgIHZhcmlhbnQgPSBcInByaW1hcnlcIixcbiAgICBhbGlnbiA9IFwiZmxleC1zdGFydFwiLFxuICAgIC4uLnJlc3RQcm9wc1xuICB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgY3NzPXtjc3NgXG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGZsZXgtZmxvdzogY29sdW1uO1xuICAgICAgICBhbGlnbi1pdGVtczogJHthbGlnbn07XG4gICAgICBgfVxuICAgID5cbiAgICAgIDxCdXR0b24gdmFyaWFudD17dmFyaWFudH0gdXJpPXt1cml9IHsuLi5yZXN0UHJvcHN9PlxuICAgICAgICB7bGFiZWx9XG4gICAgICA8L0J1dHRvbj5cbiAgICA8L2Rpdj5cbiAgKTtcbn1cbiJdfQ== */"),
    children: /* @__PURE__ */jsx(Button, {
      variant,
      uri,
      ...restProps,
      children: label
    })
  });
}
export { PostsModuleArchiveLink as default };